import { Check } from "lucide-react";

export const QuestionCard = ({ q, value, onSelect }) => {
  const isScale = q.type === "scale";
  return (
    <div className="fea-card fea-question" key={q.id} data-testid={`question-card-${q.id}`}>
      <p className="fea-overline">{q.category_label}</p>
      <p className="font-serif text-sm text-[#B8902C] mt-4">Question {q.number}</p>
      <h2 className="font-serif text-2xl sm:text-[28px] leading-snug text-[#3B121A] mt-2" data-testid="question-text">{q.text}</h2>
      {q.note && <p className="text-sm text-[#9E7381] italic mt-3" data-testid="question-note">{q.note}</p>}
      <div className={`mt-8 grid gap-3 ${isScale ? "sm:grid-cols-5" : ""}`} role="radiogroup">
        {q.options.map((o) => {
          const selected = value === o.value;
          return (
            <button
              key={o.value}
              role="radio"
              aria-checked={selected}
              onClick={() => onSelect(o.value)}
              className={`fea-option ${isScale ? "fea-option-scale" : ""} ${selected ? "is-selected" : ""}`}
              data-testid={`option-${q.id}-${o.value}`}
            >
              {isScale && <span className="fea-scale-num">{o.value}</span>}
              {!isScale && <span className="fea-radio">{selected && <Check className="h-3.5 w-3.5" />}</span>}
              <span className={isScale ? "text-sm leading-tight" : "text-left"}>{o.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
